module.exports = __webpack_public_path__ + "static/media/citydark.ef83596b.jpg";